module.exports = __webpack_public_path__ + "img/2006.ab129044.jpg";